export default {
  SET_AUTH_USER (state, value) {
    state.user = value
  },
  SET_CHOOSE_USER (state, value) {
    state.chooseUser = value
  }
}
